import { useEffect } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import { Type } from 'app/constants/TourPoints';
import { useDispatch, useSelector } from 'react-redux';
import { userHistory } from '../../../constants/user.constants';
import userAPI from '../../../API/user.service.api';
import {
  setHomeAddressUser,
  setWorkAddressUser,//eslint-disable-line
  changeShowUserHome,
  changeShowUserWork,
} from '../../../actions/Users/users.action';
import pageDataAPI from '../../../API/pageData.api';
import { getIdFromUrl } from '../../Utility/getIdFromUrl';

const ShowSpecIconsOnTheMap = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();//eslint-disable-line
  const {
    authentication = {},
    userReducer = {},
    mapScopeReducer = {},
    mapDataReducer = {},
    tourFullData = {},
  } = useSelector((store) => store);

  const {
    homeAddress = {},
    workAddress = {},
    showHome,
    showWork,
  } = userReducer;
  const { isLoggedIn, user } = authentication;
  const { scope } = mapScopeReducer;
  const { data = [] } = mapDataReducer;
  const { id, isEditMode } = tourFullData;

  const showHomeIcon = (lat, lng) =>
    publish(way.TOOL_MAP_SHOW_HOME_STATIC_ICON, {
      lat,
      lng,
      iconType: Type.HOME,
    });
  const hideHomeIcon = () => publish(way.TOOL_MAP_SHOW_HOME_STATIC_ICON, {});

  const showWorkIcon = (lat, lng) =>
    publish(way.TOOL_MAP_SHOW_WORK_STATIC_ICON, {
      lat,
      lng,
      iconType: Type.WORK,
    });
  const hideWorkIcon = () => publish(way.TOOL_MAP_SHOW_WORK_STATIC_ICON, {});

  // const showUserHisLocaion = data => {
  //     //need to add a list of scopes where we shouldn't tourch the map (drive, create_club, etc)
  //     publish(way.SHOW_USER_POSITION_FIRST_LOADING, data);
  // }

  const isProfilePageNotAuthUser = () =>
    location.pathname.includes('profile') &&
    user.id !== getIdFromUrl(location.pathname);

  const showPositionInProfile = () => {
    const { data } = userReducer;
    const { home_address = {}, work_address = {} } = data;//eslint-disable-line
    if (home_address && home_address.lat && home_address.lng) {//eslint-disable-line
      showHomeIcon(home_address.lat, home_address.lng);
    } else {
      hideHomeIcon();
    }

    if (work_address && work_address.lat && work_address.lng) {//eslint-disable-line
      showWorkIcon(work_address.lat, work_address.lng);
    } else {
      hideWorkIcon();
    }
  };

  useEffect(() => {
    if (!isLoggedIn) {
      hideHomeIcon();
      pageDataAPI.clearMyTours();
      pageDataAPI.clearMyFriendToursCacheData();
      return;
    }
    const { lat, lng } = homeAddress;
    if (isProfilePageNotAuthUser()) {
      showPositionInProfile();
    } else if (
      !lat &&
      !lng &&
      typeof lat !== 'number' &&
      typeof lng !== 'number'
    ) {
      // userAPI.getHistorySearchData(userHistory.HOME_USER_ADDRESS)
      // .then(res => {
      //     const { code, entities } = res;
      //     if(code === 200 && entities) {
      //         const data = JSON.parse(entities);
      //         if(typeof data === 'object' && data.lat && data.lng){
      //             dispatch( setHomeAddressUser(data) );
      //             // showUserHisLocaion(data);
      //         }
      //     }
      // })
      // .catch(err => console.log(err));
    } else {
      showHomeIcon(lat, lng);
    }

    if (showHome === false) {
      hideHomeIcon();
    }
  }, [scope, isLoggedIn, homeAddress, showHome, data.length]);

  const updateIconsPosition = () => {
    const { lat, lng } = homeAddress;
    if (!showWork) {
      hideWorkIcon();
      return;
    }
    if (!showHome) {
      hideHomeIcon();
      return;
    }
    if (lat && lng) {
      showHomeIcon(lat, lng);
    }
    if (workAddress.lat && workAddress.lng) {
      showWorkIcon(workAddress.lat, workAddress.lng);
    }
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    updateIconsPosition();
  }, [data.length, isEditMode]);

  useEffect(() => {
    if (!isLoggedIn) return;
    setTimeout(() => {
      updateIconsPosition();
    }, 2000);
  }, [id, isEditMode]);

  // useEffect(()=>{
  //     if(!isLoggedIn){
  //         hideWorkIcon();
  //         return;
  //     }

  //     const { lat, lng } = workAddress;
  //     if(isProfilePageNotAuthUser()){
  //         showPositionInProfile();
  //     }else if(!lat && !lng && typeof lat !== 'number' && typeof lng !== 'number'){
  //         userAPI.getHistorySearchData(userHistory.WORK_USER_ADDRESS)
  //         .then(res => {
  //             const { code, entities } = res;
  //             if(code === 200 && entities) {
  //                 const data = typeof entiies === 'string' ? JSON.parse(entities) : entities;
  //                 if(typeof data === 'object'){
  //                    dispatch(setWorkAddressUser(data) );
  //                 }
  //             }
  //         })
  //         .catch(err => console.log(err));
  //     }else{
  //         showWorkIcon(lat, lng);
  //     }
  //     if(showWork === false){
  //         hideWorkIcon();
  //         return;
  //     }
  // }, [scope, isLoggedIn, workAddress, showWork, data.length]);

  useEffect(() => {
    userAPI
      .getHistorySearchData(userHistory.HOME_USER_ADDRESS_STATUS)
      .then((res) => {
        const { code, entities } = res;
        if (code === 200 && entities) {
          const data =
            typeof entiies === 'string' ? JSON.parse(entities) : entities;
          if (typeof data === 'object') {
            const { status } = data;
            if (status === 0) dispatch(changeShowUserHome(!!status));
          }
        }
      })
      .catch((err) => console.log(err));
    userAPI
      .getHistorySearchData(userHistory.WORK_USER_ADDRESS_STATUS)
      .then((res) => {
        const { code, entities } = res;
        if (code === 200 && entities) {
          const data =
            typeof entiies === 'string' ? JSON.parse(entities) : entities;
          if (typeof data === 'object') {
            const { status } = data;
            if (status === 0) dispatch(changeShowUserWork(!!status));
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      hideHomeIcon();
      pageDataAPI.clearMyTours();
      pageDataAPI.clearMyFriendToursCacheData();
      return;
    }
    const { lat, lng } = homeAddress;
    if (isProfilePageNotAuthUser()) {
      showPositionInProfile();
    } else if (
      !lat &&
      !lng &&
      typeof lat !== 'number' &&
      typeof lng !== 'number'
    ) {
      userAPI
        .getHistorySearchData(userHistory.HOME_USER_ADDRESS)
        .then((res) => {
          const { code, entities } = res;
          if (code === 200 && entities) {
            const data = JSON.parse(entities);
            if (typeof data === 'object' && data.lat && data.lng) {
              dispatch(setHomeAddressUser(data));
            }
          }
        })
        .catch((err) => console.log(err));
    } else {
      showHomeIcon(lat, lng);
    }

    if (showHome === false) {
      hideHomeIcon();
    }
  }, [scope, isLoggedIn, homeAddress, showHome, data.length]);

  return '';
};

export default ShowSpecIconsOnTheMap;
